import React, { useState } from 'react'
import { Dropdown } from 'react-bootstrap'
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { deleteHolidayTypeAsync, getHolidayTypesByIdAsync,updateHolidayTypeAsync, checkedState, unCheckedState, checkedAllState, unCheckedAllState,updateSorting } from './holidayTypeSlice';
import {updateAccountHolidayTypeId} from '../holidayTypeDetail/holidayTypeDetailSlice';
import { colors } from 'react-select/dist/declarations/src/theme';
import HolidayTypeDetail from '../holidayTypeDetail/HolidayTypeDetail';
import BillingType from '../billingType/BillingType';
import { Link ,useNavigate} from 'react-router-dom';
import { KTIcon } from '../../../_metronic/helpers';
import { ShowSwalWithConfirmation } from '../../../common/SweetAlert';
import CustomPagination from "../../../common/Pagination";
import { ShowToast } from '../../../common/Toastr';
import clsx from "clsx";
import { setItemStatus, getValueFromResource} from '../../../common/timeLiveFunction';

const itemClass = 'ms-1 ms-lg-0';

const HolidayTypeItems = (props: any) => {
    const { holidayTypeList, modelRef, t, onopenModal, oncloseModal, IsEdit, IsDelete } = props;
    const dispatch = useAppDispatch();
    const { isLoading,sortOrder, sortColumn,pageSize } = useAppSelector((state) => state.holidayType);
    const navigate = useNavigate();

    const handleCheckboxChange = (e: any, rowId: any) => {

        if (e.target.checked) {
            dispatch(checkedState(rowId))
        } else {
            dispatch(unCheckedState(rowId))
        }
    };
    const onEditClick = (AccountHolidayTypeId: number) => {
        dispatch(getHolidayTypesByIdAsync(AccountHolidayTypeId))
            .unwrap()
            .then((originalPromiseResult) => {
                onopenModal();
            })
            .catch((rejectedValueOrSerializedError) => {

            })
    }

    const onDeleteClick = (AccountHolidayTypeId: number) => {
        ShowSwalWithConfirmation('Are you sure you want to delete this record?', "")
            .then((result) => {
                if (result) {
                    dispatch(deleteHolidayTypeAsync(AccountHolidayTypeId))
                        .unwrap()
                        .then((originalPromiseResult) => {
                            originalPromiseResult.StatusCode === "200" ?
                                ShowToast("Holiday type deleted Successfully", 'Success', "success", "toast-top-right") :
                                ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                        })
                        .catch((rejectedValueOrSerializedError) => {
                            ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
                        })
                }
            })
            .catch((error) => {

            });
    }

    const handleSelectAllChange = (e: any) => {
        const { checked } = e.target;
        if (checked) {
            dispatch(checkedAllState());
        } else {
            dispatch(unCheckedAllState());
        }
    };

    const handleIsDisabledChange = (e: any, AccountHolidayType: any) => {
        const { checked } = e.target;
        const foundIndex = holidayTypeList.findIndex((item: any) => item.AccountHolidayTypeId === AccountHolidayType.AccountHolidayTypeId);
        if (foundIndex !== -1) {
            const foundItem = holidayTypeList[foundIndex];
            const { isSelected,IsParent,IsDeleted, ...updatedItem } = foundItem;

            updatedItem.IsDisabled = checked;
            const modifiedList = [...holidayTypeList.slice(0, foundIndex), updatedItem, ...holidayTypeList.slice(foundIndex + 1)];
            dispatch(updateHolidayTypeAsync(updatedItem))
                .unwrap()
                .then((originalPromiseResult) => {
                    originalPromiseResult.StatusCode === "200" ?
                        ShowToast("Holiday type Update Successfully", 'Success', "success", "toast-top-right") :
                        ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                })
                .catch((rejectedValueOrSerializedError) => {
                    ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
                })
        }
    }

    const navigateToHolidayDetails = (obj: any) => {
        // navigate('/holidaytypedetail', { state: { obj } });
        localStorage.setItem('objholidaytypeId', JSON.stringify(obj));
        navigate(`/holidaytypedetail/${obj.AccountHolidayTypeId}`);
        dispatch(updateAccountHolidayTypeId(obj.AccountHolidayTypeId));
    };
    
    const onHandleClientSideSorting = (sortOrder: string, sortColumn: string) => {
        dispatch(updateSorting({
            "sortOrder": sortOrder,
            "sortColumn": sortColumn,
            "pageSize": pageSize,
            "pageNo": 1
        }));
    }

    return (
        <>
       
            <table className="table table-row-bordered  align-middle gs-1 gy-1 gx-1" >
                <thead>
                    <tr className="thHeading align-middle "  >
                    <th style={{width:'15%'}}>
                        {/* {t('Active / Inactive')} */}
                        {getValueFromResource('Active / Inactive',dispatch, t)}
                        {sortColumn === 'IsDisabled' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "IsDisabled") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "IsDisabled") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "IsDisabled") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "IsDisabled") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}

                        </th>
                        <th style={{width:'75%'}}>
                            {/* {t('Holiday Type')} */}
                            {getValueFromResource('Holiday Type',dispatch, t)}
                             {sortColumn === 'AccountHolidayType' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "AccountHolidayType") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "AccountHolidayType") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "AccountHolidayType") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "AccountHolidayType") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}</th>
                        {/* {IsEdit &&
                            <th className='w-15'>{t('Active / Inactive')}</th>
                        } */}
                        <th className='w-10 text-center'></th>
                    </tr>
                </thead>
                <tbody>
                    {holidayTypeList.length > 0 && holidayTypeList.map((holidayTypeDetail: any, i: any) => (
                        <tr key={i}>
                            <td>
                                <span className={clsx('timeOffStatus-td app-navbar-item badge ', setItemStatus(holidayTypeDetail.IsDisabled === 'No' ? "Active" : "InActive"))}>
                                    {holidayTypeDetail.IsDisabled === 'No' ? "Active" : "InActive"}
                                </span>
                            </td>
                            <td className='text-gray-800  text-hover-primary custom-pointer-cursor ' onClick={IsEdit ? () => onEditClick(holidayTypeDetail.AccountHolidayTypeId) : undefined}>
                                <span className="   d-block "
                                >{holidayTypeDetail.AccountHolidayType}</span>
                            </td>
                            {/* {IsEdit &&
                                <td className='text-center'>

                                    <div className="form-check form-switch form-check-custom">
                                        <input
                                            type="checkbox"
                                            className="form-check-input custom-padding-right h-15px w-30px"
                                            id="IsDisabled"
                                            checked={holidayTypeDetail.IsDisabled === 'Yes' ? true : false}
                                            onChange={(e) => { handleIsDisabledChange(e, holidayTypeDetail) }}
                                        />
                                         
                                    </div>

                                </td>
                            } */}
                             <td className='text-center'>
                                <Dropdown
                                    style={{ marginLeft: 1 }}
                                    className={clsx('cursor-pointer symbol')}
                                    data-kt-menu-attach='parent'
                                    data-kt-menu-placement='bottom-end'
                                >
                                    <Dropdown.Toggle
                                        variant="transparent"
                                        className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                                        data-tooltip-id="tooltip-Description"
                                        data-tooltip-content=
                                        // {t("More")}
                                        {getValueFromResource('More',dispatch, t)}
                                        data-tooltip-place="top"
                                    >
                                        <i className="bi bi-three-dots fs-7"></i>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 px-1 py-1 fs-2 w-150px'>
                                            {IsEdit &&
                                                <>
                                                    <div className='menu-hover-bg-sec'>
                                                        <Dropdown.Item
                                                            className="menu-item me-lg-0 "
                                                            onClick={() => {
                                                                dispatch(getHolidayTypesByIdAsync(holidayTypeDetail.AccountHolidayTypeId))
                                                                    .unwrap()
                                                                    .then((originalPromiseResult) => {
                                                                        onopenModal();
                                                                    })
                                                                    .catch((rejectedValueOrSerializedError) => {
                                                                    })
                                                            }}
                                                        >
                                                            <span className="menu-icon custom-menu">
                                                                <i className="bi bi-pencil-square fs-6 iconColor allign">
                                                                    <span className="path1"></span>
                                                                    <span className="path2"></span>
                                                                </i>
                                                            </span>
                                                            <span className="menu-title custom-menu-fontsize">
                                                                {/* {`${t('Edit')}`} */}
                                                                {getValueFromResource('Edit',dispatch, t)}
                                                                </span>
                                                        </Dropdown.Item>
                                                    </div>
                                                </>
                                            }
                                           
                                    
                                              {IsEdit && <>
                                            <div className='menu-hover-bg-pri'>
                                                <Dropdown.Item
                                                    className="menu-item me-lg-0"
                                                    onClick={() => {
                                                        navigateToHolidayDetails({
                                                            "AccountHolidayTypeId": holidayTypeDetail.AccountHolidayTypeId
                                                        });
                                                    }}
                                                >
                                                    <span className="menu-icon custom-menu">
                                                        <i className="bi bi-receipt fs-6">
                                                            <span className="path1"></span>
                                                            <span className="path2"></span>
                                                        </i>
                                                    </span>
                                                    <span className="menu-title custom-menu-fontsize">
                                                        {/* {t('View Holidays')} */}
                                                        {getValueFromResource('View Holidays',dispatch, t)}
                                                        </span>
                                                </Dropdown.Item>
                                               
                                            </div>
                                        </>}
                                            {IsDelete && IsEdit && (holidayTypeDetail.MasterHolidayTypeId === null || holidayTypeDetail.MasterHolidayTypeId === "") &&
                                                <div className='separator mb-1 mt-1 opacity-75 '></div>
                                            }
                                            {/* {IsDelete && */}
                                            {IsDelete === true && (holidayTypeDetail.MasterHolidayTypeId === null || holidayTypeDetail.MasterHolidayTypeId === "") &&
                                                <>
                                                    <div className='menu-hover-bg-danger'>
                                                        <Dropdown.Item
                                                            className="menu-item me-lg-0 "
                                                            onClick={() => { onDeleteClick(holidayTypeDetail.AccountHolidayTypeId) }}>
                                                            <span className="menu-icon  custom-menu">
                                                                <i className="bi bi-trash fs-6 delete-menu-icon-color allign" >
                                                                    <span className="path1"></span>
                                                                    <span className="path2"></span>
                                                                </i>
                                                            </span>
                                                            <span className="menu-title   delete-menu custom-menu-fontsize"  >
                                                                {/* {`${t('Delete')}`} */}
                                                                {getValueFromResource('Delete',dispatch, t)}
                                                                </span>
                                                        </Dropdown.Item>
                                                    </div>
                                                </>
                                            }
                                        </Dropdown.Menu>
                                    </Dropdown>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            
            {holidayTypeList.length === 0 &&
                                    <div className=''>
                                        <p className='noDataFound'>
                                            {/* {t('No Record Found')} */}
                                            {getValueFromResource('No Record Found',dispatch, t)}
                                            </p>
                                    </div>
                                }

        </>
    )
  
}

export default HolidayTypeItems